export const FETCH_STATUS = 'FETCH_STATUS';
export const FETCH_STATUS_SUCCESS = 'FETCH_STATUS_SUCCESS';
export const FETCH_STATUS_FAILURE = 'FETCH_STATUS_FAILURE';
export function getStatues() {
  console.log('log data = ')
  return { type: FETCH_STATUS };
}
